import { createContext } from 'react';

export const SidebarStateContext = createContext<{ 
  which: 'mobile' | 'desktop'; isVisible: { mobile: boolean; desktop: boolean } 
}>({ which: 'desktop', isVisible: {
  mobile: false,
  desktop: true,
} });